import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { UniqueCsvFlow } from "@/features/CouponCodes/Csv/StepFlow";

const searchSchema = z.object({
  discountName: z.string().min(1),
});

export const Route = createFileRoute(
  "/_auth/settings/$siteId/coupon-codes/new/unique/csv",
)({
  validateSearch: zodValidator(searchSchema),
  component: UniqueCsvRoute,
});

function UniqueCsvRoute() {
  const { siteId } = Route.useParams();
  const { discountName } = Route.useSearch();
  const navigate = useNavigate();

  const handleClose = () => {
    void navigate({
      to: "/settings/$siteId/coupon-codes",
      params: { siteId },
    });
  };

  const handleBack = () => {
    void navigate({
      to: "/settings/$siteId/coupon-codes/new/unique",
      params: { siteId },
      search: { discountName },
    });
  };

  return (
    <UniqueCsvFlow
      siteId={siteId}
      discountName={discountName}
      onClose={handleClose}
      onBack={handleBack}
    />
  );
}
